import { HTTP_STATUS_CODES } from '@common/constants';
import { ProphecyError } from '@prophecy/utils/error';
import { createContext } from 'react';

import { DEFAULT_CUSTOMER_BALANCE, DEFAULT_PROFESSIONAL_METERING_INFO } from './constants';
import { CustomerBalance, ProfessionalMeteringInfo } from './types';

interface ProfessionalEditionCreditsContextType {
  meteringInfo: ProfessionalMeteringInfo;
  isLoading: boolean;
  refetch: () => void;
  activeTeamId: string;
  setActiveTeamId: (teamId: string) => void;
  error: ProphecyError | null;
  updateMeteringInfo: (updates: Partial<ProfessionalMeteringInfo>) => void;
  customerBalance: CustomerBalance;
}

export const computeError = (error: ProphecyError | null) => {
  if (error?.message.includes('Failed to get metering info')) {
    return new ProphecyError('Could not fetch credits details. Please retry');
  }

  if (error?.cause === HTTP_STATUS_CODES.NOT_FOUND.toString()) {
    return new ProphecyError('No credits found for this team');
  }
  return error;
};

export const ProfessionalEditionCreditsContext = createContext<ProfessionalEditionCreditsContextType>({
  meteringInfo: DEFAULT_PROFESSIONAL_METERING_INFO,
  isLoading: false,
  refetch: () => {},
  setActiveTeamId: () => {},
  activeTeamId: '',
  error: null,
  updateMeteringInfo: () => {},
  customerBalance: DEFAULT_CUSTOMER_BALANCE
});
